// @flow
import moment from 'moment';

import type { Criteria, Platforms, Years } from '../types/Criteria';

export const SEARCH_SET_CRITERIA = 'search/SET_CRITERIA';
export const SEARCH_INCREASE_PAGE = 'search/INCREASE_PAGE';
export const SEARCH_DECREASE_PAGE = 'search/DECREASE_PAGE';
export const SEARCH_SET_DOCUMENTS_PER_PAGE = 'search/SET_DOCUMENTS_PER_PAGE';
export const SEARCH_SET_PAGE = 'search/SET_PAGE';
export const SEARCH_SET_MIN_DATE = 'search/MIN_DATE';
export const SEARCH_SET_MAX_DATE = 'search/MAX_DATE';
export const SEARCH_SET_YEARS_MUST_USE = 'search/YEARS_MUST_USE';

type State = {
  query: string,
  criteria: Criteria,
  platforms: Platforms,
  access: Array<string>,
  years: Years,
  adv: string,
  author: Array<string>,
  type: Array<string>,
  translations: Array<string>,
  journalsPublications: Array<string>,
  booksPublications: Array<string>,
  hypothesesPublications: Array<string>,
  pagination: {
    currentPage: number,
    documentsPerPage: number
  },
  sort: string
};

export const initialState: State = {
  query: '',
  criteria: [],
  platforms: {
    OJ: false,
    OB: false,
    HO: false,
    CO: false
  },
  access: [],
  years: {
    min: 1970,
    max: parseInt(moment().format('YYYY'), 0),
    mustUse: false
  },
  author: [],
  type: [],
  translations: [],
  journalsPublications: [],
  booksPublications: [],
  hypothesesPublications: [],
  adv: '',
  pagination: {
    currentPage: 1,
    documentsPerPage: 12
  },
  sort: ''
};

function reducer(state: State = initialState, action: any): State {
  const { type, payload } = action;

  switch (type) {
    case SEARCH_SET_CRITERIA:
      // Remove undefined keys from query parameters
      Object.keys(payload).forEach(
        key => payload[key] === undefined && delete payload[key]
      );

      return {
        ...state,
        ...payload
      };

    case SEARCH_INCREASE_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: state.pagination.currentPage + 1
        }
      };

    case SEARCH_DECREASE_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage:
            state.pagination.currentPage < 2
              ? 1
              : state.pagination.currentPage - 1
        }
      };

    case SEARCH_SET_DOCUMENTS_PER_PAGE:
      return {
        ...state,
        pagination: {
          currentPage: 1,
          documentsPerPage: payload.documentsPerPage
        }
      };

    case SEARCH_SET_PAGE:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: payload || 1
        }
      };

    case SEARCH_SET_MIN_DATE:
      return {
        ...state,
        years: {
          ...state.years,
          min: payload,
          mustUse: true
        }
      };

    case SEARCH_SET_MAX_DATE:
      return {
        ...state,
        years: {
          ...state.years,
          max: payload,
          mustUse: true
        }
      };

    case SEARCH_SET_YEARS_MUST_USE:
      const years = !payload
        ? initialState.years
        : {
            ...state.years,
            mustUse: payload
          };

      return {
        ...state,
        years
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/search.js